import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { TimelineItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ResolvingNowItem } from "web_myplann/NotificationCenter/Components/ResolvingNowItem";

interface ResolvingNowSectionProps {
	items: TimelineItemResponseDTO[];
	onItemClick?: (item: TimelineItemResponseDTO) => void;
}

export const ResolvingNowSection: FC<ResolvingNowSectionProps> = ({
	items,
	onItemClick,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	if (items.length === 0) {
		return null;
	}

	return (
		<Stack
			data-testid="resolving-now-section"
			sx={{ backgroundColor: theme.palette.grey[100] }}
		>
			<Typography
				fontSize={11}
				fontWeight={600}
				color={theme.palette.grey[600]}
				sx={{
					textTransform: "uppercase",
					letterSpacing: 0.5,
					px: 1.6,
					pt: 1.2,
					pb: 0.8,
				}}
			>
				{t(Resources.NotificationCenter.UpcomingGroups.ResolvingNow)}
			</Typography>
			<Box sx={{ mb: 1.2 }}>
				{items.map((item, index) => (
					<ResolvingNowItem
						key={item.id}
						item={item}
						onClick={onItemClick}
						isLast={index === items.length - 1}
					/>
				))}
			</Box>
		</Stack>
	);
};
